import Vue from "vue";
import Vuex from "vuex";
import user from "./user";
import shared from "./shared";
import survey from "./survey/index";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    user,
    shared,
    survey
  }
});
